import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      backgroundColor: '#f8fafc',
      borderTop: '1px solid #e2e8f0',
      padding: '32px 20px 24px',
      marginTop: 'auto',
      width: '100%'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        {/* Main footer content */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: '32px'
        }}>
          {/* Brand section */}
          <div style={{ flex: '1', minWidth: '250px' }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '700',
              color: '#2563eb',
              marginBottom: '8px'
            }}>
              MagicFamConcierge
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#64748b',
              lineHeight: '1.5',
              marginBottom: '0'
            }}>
              Your concierge-like hub for making family life easier, more organized, and more fun.
            </p>
          </div>

          {/* Links section */}
          <div style={{
            display: 'flex',
            gap: '32px',
            flexWrap: 'wrap'
          }}>
            {/* Legal links */}
            <div>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '12px'
              }}>
                Legal
              </h4>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <Link
                  to="/privacy-policy"
                  style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#2563eb';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms-of-service"
                  style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#2563eb';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  Terms of Service
                </Link>
              </div>
            </div>

            {/* Features links */}
            <div>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '12px'
              }}>
                Features
              </h4>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
              }}>
                <Link
                  to="/dashboard"
                  style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#2563eb';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  Gift Recommendations
                </Link>
                <Link
                  to="/recipes"
                  style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#2563eb';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  Recipe Collections
                </Link>
                <Link
                  to="/manage"
                  style={{
                    fontSize: '14px',
                    color: '#64748b',
                    textDecoration: 'none',
                    transition: 'color 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.color = '#2563eb';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.color = '#64748b';
                  }}
                >
                  Family Management
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid #e2e8f0',
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#64748b',
            margin: '0'
          }}>
            © {currentYear} T.A. Trussell Management, LLC. All rights reserved.
          </p>
          
          <div style={{
            display: 'flex',
            gap: '16px',
            alignItems: 'center'
          }}>
            <span style={{
              fontSize: '12px',
              color: '#94a3b8',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              Made with 
              <span style={{ color: '#ef4444' }}>❤️</span> 
              for families
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}